<template>
  <div class='switchRole' v-if="userList.length>0">
    <van-tabs v-model="active" title-active-color='#0A59F7' color='#0A59F7' :ellipsis='false' @change='onChange'>
            <van-tab :title="item.studentName" :name='i' v-for='(item,i) in userList' :key='i'></van-tab>
    </van-tabs>
  </div>
</template>
<script>
  import { HomePostUserInfo } from "@/api/api.common";
  import {queryIdentityByUserId,switchUserIdentity} from '@/api/api.mine.js';
  export default {
    data() {
      return {
        active:0,
        userList:[],
      }
    },
    created(){
      this.getUser();
    }, 
    methods: {
      getUser(){
         queryIdentityByUserId({userId:this.loginUser.userId,channelCode:From}).then(data=>{
           this.userList=data.result.parentList;
         })
      },
      onChange(){
          let identityId=this.userList[this.active].parentId;
          localStorage.setItem("identityId",identityId)
          switchUserIdentity({identityId:identityId,userType:5}).then(data=>{
              if(data.code=='00000'){
                this.getUserInfo();
              }else{
                this.$toast(data.message)
              }
          })
      },
      // 用户信息
      getUserInfo() {
          HomePostUserInfo().then((res) => {
            if (res && res.result) {
              this.$store.commit("setLoginUser", res.result);
              this.$emit('changes');
              this.getImeis();
            }else{
            this.$toast(res.message);
            }
          });
      }
    },
  }
</script>
<style lang="scss" >
.switchRole{
  border-bottom:1px solid #eee;
  .van-tab{
      color:rgba(0,0,0,.6);
      font-size: .16rem;
    }
}

</style>